<template>
  <section id="places-modal" key="modal" :class="[ { open: activeModal !== ''} ]">
    <div class="header">
      <div class="close" @click="close">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none">
          <path fill="#58554D" fill-rule="evenodd" d="M16 .5L17.5 2l-7 7 7 7-1.5 1.5-7-7-7 7L.5 16l7-7-7-7L2 .5l7 7 7-7z" clip-rule="evenodd" />
        </svg>
      </div>
    </div>

    <div id="results">
      <div
        v-for="place in places"
        :key="place.id"
        :class="['result', { active: activeModal === place.id } ]"
        :data-result-id="place.id"
      >
        <div class="intro">
          <h3 class="h2" v-html="place.title" />
          <h4 v-if="place.details.length > 0" class="h3 subtitle" v-html="place.details[0].subtitle" />
        </div>

        <div v-if="place.details.length > 0" class="image">
          <img v-for="image in place.details[0].image" :key="image.id" :src="image.url" :alt="image.title">
        </div>

        <div v-if="place.details.length > 0" class="description" v-html="place.details[0].description" />

        <div class="contact">
          <div v-if="place.place" class="address">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              class="icon-marker"
            >
              <path fill="#58554D" d="M12 18.5l-.5547.8321.5514.3676.5534-.3646L12 18.5zm0 0c.5501.8351.5504.8349.5506.8348a.0275.0275 0 01.0025-.0017l.0056-.0037.0192-.0128a18.1371 18.1371 0 00.3216-.2222c.215-.152.5192-.373.8831-.6536.726-.5599 1.6976-1.3635 2.6731-2.3352.9724-.9685 1.9705-2.1256 2.7305-3.3952C19.9434 11.4454 20.5 10.0086 20.5 8.5h-2c0 1.0209-.3809 2.0989-1.0299 3.1832-.6463 1.0796-1.5232 2.1063-2.4258 3.0054-.8995.896-1.8029 1.6439-2.4831 2.1685-.3393.2616-.621.4662-.8162.6042a16.2711 16.2711 0 01-.2238.1555c-.0252.0172-.0441.0299-.0561.038l-.0129.0086-.0025.0016-.0003.0002.0002-.0001c.0001-.0001.0003-.0002.5504.8349zm-8.5-10c0 1.4959.558 2.9259 1.3144 4.1864.7595 1.2658 1.7569 2.4241 2.7285 3.3957.9748.9748 1.9458 1.7836 2.6713 2.3479.3636.2828.6676.5057.8823.6591a17.2976 17.2976 0 00.3211.2243l.0192.013.0056.0037a.0279.0279 0 00.0024.0016c.0003.0002.0005.0004.5552-.8317.5547-.8321.5549-.8319.555-.8319l.0001.0001-.0003-.0002-.0025-.0017-.013-.0087a15.758 15.758 0 01-.2803-.1959 25.1065 25.1065 0 01-.8169-.6104c-.6808-.5295-1.5848-1.2832-2.485-2.1834-.9034-.9034-1.781-1.9326-2.4277-3.0105C5.8794 10.5741 5.5 9.5041 5.5 8.5h-2zM12 0C7.3056 0 3.5 3.8056 3.5 8.5h2C5.5 4.9101 8.4101 2 12 2V0zm8.5 8.5C20.5 3.8056 16.6944 0 12 0v2c3.5899 0 6.5 2.9101 6.5 6.5h2zm-8.5-2c.8284 0 1.5.6716 1.5 1.5h2c0-1.933-1.567-3.5-3.5-3.5v2zM10.5 8c0-.8284.6716-1.5 1.5-1.5v-2c-1.933 0-3.5 1.567-3.5 3.5h2zM12 9.5c-.8284 0-1.5-.6716-1.5-1.5h-2c0 1.933 1.567 3.5 3.5 3.5v-2zM13.5 8c0 .8284-.6716 1.5-1.5 1.5v2c1.933 0 3.5-1.567 3.5-3.5h-2z" />
              <path stroke="#58554D" stroke-width="2" d="M6 23h12" />
            </svg>
            <p>
              {{ place.place.parts.number }} {{ place.place.parts.address }} <br>{{ place.place.parts.city }}, {{ place.place.parts.state }} {{ place.place.parts.zip }}
            </p>
          </div>

          <p v-if="place.details.length > 0" class="eta" v-html="place.details[0].walkingEta" />
        </div>

        <div v-if="place.details.length > 0 && place.details[0].website" class="website">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="none"
            viewBox="0 0 25 25"
            class="icon-website"
          >
            <path
              stroke="#58554D"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16.75 23.5c3.7279 0 6.75-3.0221 6.75-6.75S20.4779 10 16.75 10 10 13.0221 10 16.75s3.0221 6.75 6.75 6.75z"
              clip-rule="evenodd"
            />
            <path
              stroke="#58554D"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10.3838 19h12.732M10.3838 14.5h12.732M15.294 10.1582a21.8623 21.8623 0 00.51 13.276M18.2062 10.1582a21.7336 21.7336 0 01.794 5.842 21.7001 21.7001 0 01-1.3 7.434"
            />
            <path
              stroke="#58554D"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M22 7.75V2.616c-.0022-.8912-.7238-1.6133-1.615-1.616H2.607c-.8864.0028-1.6043.7206-1.607 1.607v15.528c.0028.8908.7242 1.6123 1.615 1.615H7M1 5.5h21M7 1v4.5M11.5 1v4.5"
            />
          </svg>

          <a :href="place.details[0].website" target="blank" rel="noopener noreferrer" class="mobile-btn">Visit Website</a>
          <a :href="place.details[0].website" target="blank" rel="noopener noreferrer" class="desktop-btn" v-html="place.details[0].website" />
        </div>

        <div v-if="place.details.length > 0 && place.details[0].phoneNumber" class="phone">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="24"
            fill="none"
            viewBox="0 0 26 24"
            class="icon-phone"
          >
            <path
              stroke="#58554D"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.5"
              d="M5.535 2.738h-.011C3.4638 3.1957 1.9985 5.0236 2 7.134v.89a1.5 1.5 0 001.5 1.5h3.75c.8284 0 1.5-.6715 1.5-1.5 0-.8284.6716-1.5 1.5-1.5h6c.8284 0 1.5.6716 1.5 1.5 0 .8285.6716 1.5 1.5 1.5H23c.8284 0 1.5-.6715 1.5-1.5v-.89c.0001-2.1092-1.4649-3.9355-3.524-4.393h-.011a40.613 40.613 0 00-15.43-.003z"
              clip-rule="evenodd"
            />
            <path
              stroke="#58554D"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M7.625 13.2739a.375.375 0 100 .75.375.375 0 000-.75M13.25 13.2739a.375.375 0 100 .75.375.375 0 000-.75M18.875 13.2739a.375.375 0 100 .75.375.375 0 000-.75M7.625 17.7739a.375.375 0 100 .75.375.375 0 000-.75M13.25 17.7739a.375.375 0 100 .75.375.375 0 000-.75M18.875 17.7739a.375.375 0 100 .75.375.375 0 000-.75M7.625 22.2739a.375.375 0 100 .75.375.375 0 000-.75M13.25 22.2739a.375.375 0 100 .75.375.375 0 000-.75M18.875 22.2739a.375.375 0 100 .75.375.375 0 000-.75"
            />
          </svg>

          <a :href="`tel:${place.details[0].phoneNumber}`" class="mobile-btn">Call</a>
          <a :href="`tel:${place.details[0].phoneNumber}`" class="desktop-btn" v-html="place.details[0].phoneNumber" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
  name: 'PlacesModal',
  props: {
    modal: {
      type: String,
      required: false,
      default: ''
    },
    places: {
      type: Array,
      required: true,
      default: []
    }
  },
  data () {
    return {
      activeModal: '',
      scrollOptions: {
        container: '#results',
        easing: 'ease-out',
        force: true,
        cancelable: true,
        onStart: (el) => {},
        onDone: (el) => {},
        onCancel: () => {},
        x: false,
        y: true
      }
    }
  },
  watch: {
    modal (newValue, oldValue) {
      if (newValue !== '') {
        this.activeModal = newValue
        VueScrollTo.scrollTo(`[data-result-id="${this.activeModal}"]`, 1000, this.scrollOptions)
      }
    }
  },
  methods: {
    close () {
      this.activeModal = ''
      this.$emit('modalClosed', this.activeModal)
    }
  }
}
</script>
